const CONST = require('plugin_frontend_core/constants');

const selectors = {
    pboContainer: '.js-product-back-order-container',
    pboLink: '.js-product-back-order-link',
    pboModal: '.js-product-back-order-modal',
    pboForm: '.js-product-back-order-form',
    pboAtcError: '.js-atc-error',
    pboSizeSelect: '.js-size-select',
    pboFeedback: '.js-product-back-order-feedback',
    pboSuccessScreen: '.js-product-back-order-success-screen',
    sizeVariations: '.product-detail-variants__size'
};

const attributes = {
    modalTitle: 'data-modal-title',
    stockFormUrl: 'data-stockform-url',
    genericError: 'data-resource-genericerror'
};

const dataValues = {
    modalTitle: 'modal-title'
};

const $document = $(document);


/**
 * Creates a modal element
 * @param {jQuery.event} e - Event
 */
function formSubmitHandler(e) {
    e.preventDefault();
    const $form = $(e.target);
    const $feedback = $(selectors.pboFeedback);
    const $successScreen = $(selectors.pboSuccessScreen);
    const url = $form.attr(CONST.attributes.action);

    $form.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: function (data) {
            $form.spinner().stop();
            $(selectors.pboAtcError).remove();
            
            if (!data.success) {
                $feedback.html(`
                    <p class="error">${data.errorMessage}</p>
                `).removeClass(CONST.classes.dNone);
            } else {
                $form.addClass(CONST.classes.dNone);
 
                $successScreen.html(`
                    <p>${data.successMessage}</p>
                `).removeClass(CONST.classes.dNone);
            }
        },
        error: function (err) {
            $form.spinner().stop();
            console.error('Out of stock eror:', err);

            var errorResource = $feedback.attr(attributes.genericError);

            $feedback.html(`
                <p class="error">${errorResource}</p>
            `).removeClass(CONST.classes.dNone);
        }
    });
}

/**
 * Get the new modal html from the BE and update the DOM.
 * @param {jQuery.event} e - Event
 * @param {Object} response - the response
 */
function setModalData(e, response) {
    const $pboContainer = $(selectors.pboContainer);
    const $pboLink = $(selectors.pboLink);
    const $pboModal = $(selectors.pboModal);
    const responseProduct = response.data.product;
    const variationId = responseProduct.variationGroupID;
    const variationAttributes = responseProduct.variationAttributes;
    let variationColor;

    for (var i = 0; i < variationAttributes.length; i++) {
        if (variationAttributes[i].attributeId === 'size') {
            const sizeValues = variationAttributes[i].values;
            let hasUnselectableVariant = false;

            for (var vai = 0; vai < sizeValues.length; vai++) {
                if (!sizeValues[vai].selectable) {
                    hasUnselectableVariant = true;
                }

                if (sizeValues[vai].selected) {
                    $pboModal.attr('data-selected-size', sizeValues[vai].id);
                    $pboModal.attr('data-selected-var-id', sizeValues[vai].pvid);
                }
            }

            if (!hasUnselectableVariant) {
                $pboContainer.addClass(CONST.classes.dNone);
            } else {
                $pboContainer.removeClass(CONST.classes.dNone);
            }
            

        } else if (variationAttributes[i].attributeId === 'color') {
            variationColor = variationAttributes[i]['selectedValue'];
        }
    }

    if (!variationId || !variationColor) {
        return;
    }

    const stockFormUrl = $pboModal.attr(attributes.stockFormUrl) + variationId;

    $.ajax({
        url: stockFormUrl,
        type: 'get',
        dataType: 'html',
        success: function (data) {
            var $data = $(data);
            if ($data.find(selectors.pboForm)) {
                $pboModal.html(data);
                $pboLink.data(dataValues.modalTitle, `${$pboLink.attr(attributes.modalTitle)} ${variationColor}`);
            }
        },
        error: function (err) {
            console.error('setModalData:', err);
        }
    });
}

function openOutOfStockErrorModal(e, data){
    const $pboModal = $(selectors.pboModal);
    const $pboLink = $(selectors.pboLink);
    const selectedProductId = $pboModal.attr('data-selected-var-id') || false;
    const selectedProductSize = $pboModal.attr('data-selected-size') || false;
    let $pboSizeSelector = $pboModal.find(selectors.pboSizeSelect);

    // add error txt to modal
    $('<p/>', {
        class : 'atc__error js-atc-error',
        text: data.message
    }).prependTo($pboModal);

    // get the original size options
    let sizes = [];
    let $orgSelectOptions = $pboSizeSelector.find('option');
    $orgSelectOptions.each(function(i){
        if ($(this).attr('value') !== selectedProductId) {
            sizes.push([$(this).text().trim(), $(this).attr('value')]);
        }
    });

    //  Add the sold out variant
    if (selectedProductId && selectedProductSize) {
        sizes.push([selectedProductSize, selectedProductId]);
    }

    // Sort sizes
    sizes.sort(function(a, b) {
        return a[0] - b[0];
    });

    // remove existing options
    $orgSelectOptions.remove();

    // Create new options
    for (let size in sizes) {
        let $newoption = $('<option/>', {
            value: sizes[size][1],
            text: sizes[size][0]
        });

        if (selectedProductSize === sizes[size][0]) {
            $newoption.attr('selected', 'selected');
        }
        $newoption.appendTo($pboSizeSelector)
    }

    $pboLink.trigger('click');
}

/**
 * Initializes the module
 */
function init() {
    $document.on(CONST.events.submit, selectors.pboForm, formSubmitHandler);
    $document.on(CONST.events.productAfterAttributeSelect, setModalData);
    $('body').on('modal:ShowOutOfStock', openOutOfStockErrorModal);
}

module.exports = {
    init: init
};
